// disable no-invalid-getInitialProps
/* eslint-disable react/prop-types */
// disable no-invalid-getInitialProps
import { useState } from 'react';
import styled from '@emotion/styled';
import { getImage } from '@utils/imageHelper';
import Button from '@base/Button/Button';
import Dropdown from '@comp/Dropdown/Dropdown';
import { breakpoints } from '@styles/index';
import Logo from '@comp/Logo/Logo';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { useIsMobile } from '@stores/AppCommonData';

const Container = styled.div`
  text-align: center;
  margin-top: 90px;
  @media (max-width: ${breakpoints.mobile}) {
    margin: auto 16px;
    margin-top: 40px;
  }
`;

const AppBar = styled.header`
  width: 1136px;
  height: 72px;
  background: var(--color-i-white);
  display: flex;
  justify-content: space-between;
  margin: auto;
  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 16px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  box-shadow: ${boxShadowGenerator()};
`;

const FrameContainer = styled.div`
  width: 515px;
  display: flex;
  margin: auto;
  margin-top: 40px;
  justify-content: space-between;
  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

const Image = styled.img`
  width: 176px;
  height: auto;
`;

const Header = styled.h1`
  font-size: 32px;
  line-height: 120%;
  color: var(--color-i-black);
  margin-top: 40px;
  margin-bottom: 0px;
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 24px;
    margin-top: 32px;
  }
`;

const SubHeader = styled.h6`
  font-size: 20px;
  line-height: 150%;
  color: var(--color-i-black);
  margin-top: 8px;
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 16px;
  }
`;

const FrameImage = styled.img`
  width: 128px;
  height: auto;
  @media (max-width: ${breakpoints.mobile}) {
    width: 98px;
  }
`;

const Label = styled.p`
  font-weight: bold;
  font-size: 20px;
  line-height: 120%;
  color: var(--color-i-black);
  @media (max-width: ${breakpoints.mobile}) {
    font-weight: 600;
    font-size: 14px;
  }
`;

const ChatButton = styled(Button)`
  width: auto;
  padding: 18px 32px;
  margin: auto;
  margin-top: 40px;
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
    width: 100%;
  }
`;

const ImgWrapper = styled.div``;

const frames = [
  { img: 'chatbot/frame1.png', label: 'Click' },
  { img: 'chatbot/frame2.png', label: 'Crop' },
  { img: 'chatbot/frame3.png', label: 'Submit' }
];

const options = [
  {
    label: 'Class 6',
    value: 'KVBFU',
    url: 'https://unacademy.app.link/62Z2uLOvseb'
  },
  {
    label: 'Class 7',
    value: 'RJDNO',
    url: 'https://unacademy.app.link/Yp5GEXRyseb'
  },
  {
    label: 'Class 8',
    value: 'TICPI',
    url: 'https://unacademy.app.link/TEtCWtUyseb'
  },
  {
    label: 'Class 9',
    value: 'SUVLV',
    url: 'https://unacademy.app.link/iaHtLJWyseb'
  },
  {
    label: 'Class 10',
    value: 'GSZGO',
    url: 'https://unacademy.app.link/1Q0Q2TYyseb'
  },
  {
    label: 'Class 11',
    value: 'GWDPZ',
    url: 'https://unacademy.app.link/mfpGaZ0yseb'
  },
  {
    label: 'Class 12',
    value: 'PLWCX',
    url: 'https://unacademy.app.link/yaEzrS2yseb'
  }
];

const Chatbot = ({ goalUID }) => {
  const goalPresent = options.findIndex((option) => option.value === goalUID);

  const [selectedOption, setSelctedOption] = useState(
    options[goalPresent || 0]
  );
  const isMobile = useIsMobile();

  const onButtonClick = () => {
    window.open(selectedOption.url);
  };

  return (
    <>
      <Wrapper>
        <AppBar>
          <Logo />
          <Dropdown
            options={options}
            selectedOption={selectedOption}
            onOptionClick={setSelctedOption}
            buttonWidth={isMobile ? '105px' : '176px'}
          />
        </AppBar>
      </Wrapper>
      <Container>
        <Image src={getImage('chatbot/chatbotboy.png')} alt="chatbot" />
        <Header>Get your doubts cleared instantly.</Header>
        <SubHeader>3 simple steps to follow</SubHeader>
        <FrameContainer>
          {frames.map((frame) => (
            <ImgWrapper key={frame.label}>
              <FrameImage src={getImage(frame.img)} />
              <Label>{frame.label}</Label>
            </ImgWrapper>
          ))}
        </FrameContainer>
        <ChatButton label="Start Asking a Question" onClick={onButtonClick} />
      </Container>
    </>
  );
};

Chatbot.Layout = ({ children }) => children;

Chatbot.pageInfo = { isMWebSupported: true };

export default Chatbot;

Chatbot.getInitialProps = async ({ res, query }) => {
  const { goalUID } = query;
  const isServer = typeof window === 'undefined';
  const goalPresent = options.findIndex((option) => option.value === goalUID);
  if (goalPresent < 0) {
    if (isServer) {
      res.writeHead(302, {
        Location: `/goal/-/${goalUID}`
      });
      return res.end();
    }
  }
  return {
    goalUID
  };
};
Chatbot.Wrapper = PageReduxProvider;
